import request from '../utils/http'

export function login(name,password, phone, code) {
    const data = {
        name,
        password,
        phone,
        code
    }
    return request({
        url: '/api/login',
        method: 'post',
        data
    })
}

export function getcode(mobile) {
    const data = {
        mobile
    }
    return request({
        url: '/api/forgetPass/forgetPassword',
        method: 'post',
        data
    })
}

export function next(mobile,code) {
    const data = {
        mobile,
        code
    }
    return request({
        url: '/api/forgetPass/checkCode',
        method: 'post',
        data
    })
}

export function reset(mobile,password,password_confirmation) {
    const data = {
        mobile,
        password,
        password_confirmation
    }
    return request({
        url: '/api/forgetPass/setPassword',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/login.js